import { BatteryIcon } from './BatteryIcon';

/**
 * author: Google
 * id C12D919F-7D0D-4355-8109-912BA37154B5
 * name battery
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery.svg
 * tags
 * - Battery 
 * - Home Automation 
 * - Automotive 
 */
export const BatteryFullIcon = BatteryIcon;
export default BatteryFullIcon